import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      d="M81.425 6.836a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M102.318 21.764a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 1 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M90.202 21.764a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.501 1.501 0 0 1-2.122 2.12l-9.994-9.993a1.5 1.5 0 0 1 0-2.121"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M45.528 103.658a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M10.02 53.386a1.5 1.5 0 0 1 1.5 1.5V69.02a1.5 1.5 0 1 1-3 0V54.886a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M1.453 61.953a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H2.953a1.5 1.5 0 0 1-1.5-1.5M18.067 92.658a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="m60.302 19.552 6.451 7.422a2.63 2.63 0 0 0 2.57.835l9.583-2.216a2.622 2.622 0 0 1 3.201 2.33l.86 9.796a2.62 2.62 0 0 0 1.586 2.185l9.055 3.844a2.623 2.623 0 0 1 1.223 3.78l-5.067 8.429a2.63 2.63 0 0 0 0 2.7l5.067 8.429a2.624 2.624 0 0 1-1.223 3.779l-9.055 3.844a2.62 2.62 0 0 0-1.587 2.185l-.859 9.796a2.625 2.625 0 0 1-3.2 2.33l-9.585-2.216a2.63 2.63 0 0 0-2.569.834l-6.45 7.426a2.628 2.628 0 0 1-3.959 0l-6.45-7.453a2.63 2.63 0 0 0-2.57-.836l-9.584 2.216a2.622 2.622 0 0 1-3.2-2.329l-.86-9.79a2.62 2.62 0 0 0-1.587-2.184l-9.055-3.852a2.618 2.618 0 0 1-1.222-3.778l5.067-8.43c.502-.83.502-1.87 0-2.7l-5.067-8.415a2.624 2.624 0 0 1 1.222-3.78l9.055-3.83a2.62 2.62 0 0 0 1.587-2.191l.86-9.798a2.627 2.627 0 0 1 3.2-2.329l9.584 2.217a2.63 2.63 0 0 0 2.57-.835l6.45-7.423a2.623 2.623 0 0 1 3.957.006z"
    />
    <path
      fill="#D8FFFF"
      d="m60.361 39.431 4.81 10.133h8.164a2.236 2.236 0 0 1 1.611 3.826l-7.512 6.684 4.153 9.542a2.26 2.26 0 0 1-3.222 2.827l-10.04-5.647-10.04 5.647a2.26 2.26 0 0 1-3.222-2.827l4.153-9.542-7.499-6.684a2.235 2.235 0 0 1 1.611-3.826h8.165l4.81-10.133a2.284 2.284 0 0 1 4.058 0"
    />
  </svg>
);
const SvgEnrichedIconFavoriteBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconFavoriteBrand);
export default Memo;
